import type { EntityType } from '@/lib/constants/entity-types';

/**
 * React Query keys for the team feature. Scoped by entity id (and, per ADR
 * FE-1, entity type) so the cache is correct per acting entity. `entityType`
 * is optional and defaults to '' rather than required, since `entityId` is
 * already a UUID unique across every entity type - this is belt-and-suspenders
 * consistency with the documented pattern, not a correctness fix. Kept in one
 * place so query and mutation hooks invalidate the exact same keys.
 */
export const teamKeys = {
  members: (entityId: string, entityType?: EntityType) =>
    ['team', entityType ?? '', entityId, 'members'] as const,
  invites: (entityId: string) => ['team', entityId, 'invites'] as const,
  /** A single invite-token preview (accept flow, MYN-47). */
  invitePreview: (token: string) => ['invite', token] as const,
  /** Shared Startup Profile recipients (MYN-41/54/57). */
  recipients: (entityId: string) => ['team', entityId, 'recipients'] as const,
};
